import React, { useState } from "react";
import "../styles/SignUp.css";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { rgisterUser } from "../Services/AllServices";
import brainImage from "../images/brainImage.svg";
import anavuLogo from '../images/iiit_logo.png';
import backArrow from '../images/backArrow.png';
import uploadIcon from '../images/uploadIcon.png';
import dropdown_open from '../images/dropdown_open.png';  // Add your dropdown icon path here
import dropdown_close from '../images/dropdown_close.png'; // Add your dropdown icon path here

const SignUp = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    mobileNumber: '',
    email: '',
    role: '',
    password: '',
    confirmPassword: '',
    purpose: [],
    profile: '',
    ID_card: null,
  });
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [fileName, setFileName] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  
  // States for Profile Dropdown
  const [isSelectProfileDropdownOpen, setIsSelectProfileDropdownOpen] = useState(false);  // Manage profile dropdown open state
  const [profileStatus, setProfileStatus] = useState('Select Profile'); // Default label for profile dropdown

  // States for Role Dropdown
  const [isSelectRoleDropdownOpen, setIsSelectRoleDropdownOpen] = useState(false);  // Manage role dropdown open state
  const [selectedRole, setSelectedRole] = useState(''); // Default label for role dropdown

  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData({ ...formData, [id]: value });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFormData({ ...formData, ID_card: file });
    setFileName(file ? file.name : '');
  };

  const handleCheckboxChange = (e) => {
    const { id, checked } = e.target;
    if (checked) {
      setFormData({ ...formData, purpose: [...formData.purpose, id] });
    } else {
      setFormData({ ...formData, purpose: formData.purpose.filter(p => p !== id) });
    }
  };

  // Toggle for Profile Dropdown
  const toggleStatusDropdown = () => {
    setIsSelectProfileDropdownOpen(!isSelectProfileDropdownOpen);  // Toggle profile dropdown open/close state
  };

  const handleDropdownSelect = (option) => {
    setProfileStatus(option);  // Set selected profile as the label
    setFormData({ ...formData, profile: option });  // Set formData for profile
    setIsSelectProfileDropdownOpen(false);  // Close the profile dropdown after selection
  };

  // Toggle for Role Dropdown
  const toggleRoleDropdown = () => {
    setIsSelectRoleDropdownOpen(!isSelectRoleDropdownOpen);  // Toggle role dropdown open/close state
  };

  const handleRoleSelect = (role) => {
    setSelectedRole(role);  // Set selected role as the label
    setFormData({ ...formData, role: role });  // Set formData for role
    setIsSelectRoleDropdownOpen(false);  // Close the role dropdown after selection
  };

  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrorMessage("");
  
    if (!isValidEmail(formData.email)) {
      setErrorMessage("Please enter a valid email address.");
      setLoading(false);
      return;
    }
  
    if (formData.password !== formData.confirmPassword) {
      setErrorMessage("Passwords do not match.");
      setLoading(false);
      return;
    }
  
    if (profileStatus === "Select Profile") {
      setErrorMessage("Please select a profile.");
      setLoading(false);
      return;
    }
  
    if (profileStatus === "Teacher" && selectedRole === "") {
      setErrorMessage("Please select a role for the Teacher profile.");
      setLoading(false);
      return;
    }
    if (formData.purpose.length === 0) {
      setErrorMessage("Please select at least one purpose.");
      setLoading(false);
      return;
    }
  
    rgisterUser(formData, (result) => {
      setLoading(false);
      if (result.status === "success") {
        setShowPopup(true);
      } else {
        setErrorMessage(result.message || "Something went wrong during registration.");
      }
    });
  };
  
  

  const handlePopupClose = () => {
    setShowPopup(false);
    navigate('/');
  };

  return (
    <>
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-content">
            <h2>Registration Successful</h2>
            <p>Your details have been successfully submitted. Please wait for the admin to approve your registration. Thank you for your patience!</p>
            <button onClick={handlePopupClose}>OK</button>
          </div>
        </div>
      )}

      <div className="logo-container">
        <a href='/'>
          <img src={anavuLogo} alt="Anavu Logo" className="logo" />
          <div className="logo-text">Anavu</div>
        </a>
      </div>
      <div className="signup_page">
        <div className="signup_left">
          <a href="/" className="signup_backarrow"><img src={backArrow} alt="back arrow" /></a>
          <div className="signup-container">
            <form onSubmit={handleSubmit}>
              <div className="signup-heading-row">
                <h2>Sign up</h2>

                {/* Custom Dropdown for Select Profile */}
                <div className={`signup-custom-select-profile ${isSelectProfileDropdownOpen ? "open" : ""}`}>
                  <div className="signup-custom-select-profile-status" onClick={toggleStatusDropdown}>
                    {profileStatus}
                    <span className="signup-custom-select-profile-arrow">
                      {isSelectProfileDropdownOpen ? (
                        <img src={dropdown_close} alt="Dropdown Open" className="signup-dropdown-icon" />
                      ) : (
                        <img src={dropdown_open} alt="Dropdown Close" className="signup-dropdown-icon" />
                      )}
                    </span>
                  </div>
                  {isSelectProfileDropdownOpen && (
                    <div className="signup-custom-profile-options">
                      {['Teacher', 'Student'].map((option) => (
                        <div key={option} className="signup-custom-select-profile-option" onClick={() => handleDropdownSelect(option)}>
                          {option}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>

              <div className="signup-input-container">
                <input
                  type="text"
                  id="firstName"
                  placeholder="First Name"
                  value={formData.firstName}
                  onChange={handleInputChange}
                  required
                />
                <label htmlFor="firstName">First Name</label>
              </div>
              <div className="signup-input-container">
                <input
                  type="text"
                  id="lastName"
                  placeholder="Last Name"
                  value={formData.lastName}
                  onChange={handleInputChange}
                  required
                />
                <label htmlFor="lastName">Last Name</label>
              </div>
              <div className="signup-input-container">
                <input
                  type="text"
                  id="mobileNumber"
                  placeholder="Mobile Number"
                  value={formData.mobileNumber}
                  onChange={handleInputChange}
                  required
                />
                <label htmlFor="mobileNumber">Mobile Number</label>
              </div>
              <div className="signup-input-container">
                <input
                  type="email"
                  id="email"
                  placeholder="Email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                />
                <label htmlFor="email">Email</label>
              </div>

              {formData.profile === 'Teacher' && (
                <>
                 <div className="signup-input-container select-role">
                    <div className={`custom-select-role ${isSelectRoleDropdownOpen ? "open" : ""}`}>
                      <div className="custom-select-role-status" onClick={toggleRoleDropdown}>
                        {selectedRole || "Select Role"}
                        <span className="custom-select-role-arrow">
                          {isSelectRoleDropdownOpen ? (
                            <img src={dropdown_close} alt="Dropdown Open" className="dropdown-icon" />
                          ) : (
                            <img src={dropdown_open} alt="Dropdown Close" className="dropdown-icon" />
                          )}
                        </span>
                      </div>
                      {isSelectRoleDropdownOpen && (
                        <div className="custom-role-options">
                          {['Professor', 'Assistant Professor', 'HOD'].map((role) => (
                            <div key={role} className="custom-select-role-option" onClick={() => handleRoleSelect(role)}>
                              {role}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="signup-input-container upload-container">
                    <label htmlFor="idCardUpload" className="file-label">
                      {fileName || 'Upload ID Card'}
                    </label>
                    <input
                      type="file"
                      id="idCardUpload"
                      accept=".png, .jpeg, .jpg"
                      onChange={handleFileChange}
                      required
                    />
                    <img src={uploadIcon} alt="Upload Icon" className="upload_id_icon" />
                  </div>
                </>
              )}

              <div className="signup_purpose">Purpose</div>
              <div className="checklist-container">
                <div className="checklist-item">
                  <label htmlFor="education">Education</label>
                  <input type="checkbox" id="education" onChange={handleCheckboxChange} />
                </div>
                <div className="checklist-item">
                  <label htmlFor="commercial">Commercial</label>
                  <input type="checkbox" id="commercial" onChange={handleCheckboxChange} />
                </div>
                <div className="checklist-item">
                  <label htmlFor="research">Research</label>
                  <input type="checkbox" id="research" onChange={handleCheckboxChange} />
                </div>
              </div>

              <div className="signup-input-container">
                <input
                  type={showPassword ? "text" : "password"}
                  id="password"
                  placeholder="Enter Password"
                  value={formData.password}
                  onChange={handleInputChange}
                  required
                />
                <label htmlFor="password">Enter Password</label>
                <FontAwesomeIcon
                  icon={showPassword ? faEye : faEyeSlash}
                  className="password-icon"
                  onClick={() => setShowPassword(!showPassword)}
                />
              </div>

              <div className="signup-input-container">
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  id="confirmPassword"
                  placeholder="Confirm Password"
                  value={formData.confirmPassword}
                  onChange={handleInputChange}
                  required
                />
                <label htmlFor="confirmPassword">Confirm Password</label>
                <FontAwesomeIcon
                  icon={showConfirmPassword ? faEye : faEyeSlash}
                  className="password-icon"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                />
              </div>

              <button type="submit" className="signup-btn" disabled={loading}>
                {loading ? "Signing up..." : "Sign up"}
              </button>
            </form>

            {errorMessage && <div className="error-message">{errorMessage}</div>}

            <div className="separator">
              <span>or</span>
            </div>

            <div className="signup-link">
              Already have an account? <a href="/signin">Sign in</a>
            </div>
          </div>
        </div>

        <div className="signup_right">
          <img src={brainImage} alt="Brain" />
        </div>
      </div>
    </>
  );
};

export default SignUp;
